import { type NexusApiCategory } from "../workflow.types";

// ── Category definitions ──────────────────────────────────────────────────────

export const NEXUS_API_CATEGORIES: { value: NexusApiCategory; label: string }[] = [
  { value: "agents", label: "Agents" },
  { value: "tasks", label: "AI Tasks" },
  { value: "collections", label: "Collections" },
  { value: "documents", label: "Documents" },
  { value: "documentTemplates", label: "Document Templates" },
  { value: "deployments", label: "Deployments" },
  { value: "emulator", label: "Emulator" },
  { value: "inbox", label: "Inbox" },
  { value: "workflows", label: "Workflows" },
  { value: "executions", label: "Executions" },
  { value: "workspace", label: "Workspace" },
  { value: "memory", label: "Agent Memory" }
];
